import { LanguageEnum } from '../enums/global.enum';
import { Model } from '../models/model';

export class Language extends Model {
  constructor(
    public id: string = '',
    public name = 'Arabic',
    public isoCode = LanguageEnum.Arabic,
    public isDefault: boolean = false
  ) {
    super();
  }
}
